
import React from 'react';
import { makeStyles, tokens, Text, makeStaticStyles } from '@fluentui/react-components';

export const useTagContentStyles = makeStyles({
  Text: {
    fontWeight: tokens.fontWeightSemibold,
  },
  List: {
    fontWeight: tokens.fontWeightSemibold,
    alignItems: 'center',
    display: 'flex',
    columnGap: tokens.spacingHorizontalXS,
    marginBottom: tokens.spacingVerticalL,
  },
  ListItem: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  Container: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: tokens.spacingVerticalL,
  },
  ButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    columnGap: tokens.spacingHorizontalL,
    width: 'fit-content',
  },
  MessageBar: {
    width: 'fit-content',
  },
  PopoverContentBefore: {
    fontWeight: tokens.fontWeightSemibold,
    paddingLeft: tokens.spacingHorizontalS,
  },
  EntitySelector: {
    maxWidth: '100%',
    marginTop: tokens.spacingVerticalS,
  },
});

const useStaticStyles = makeStaticStyles({
  '.entities-collection-container': {
    maxWidth: '630px',
  },
});

export const CustomWebsiteListTagItemRenderer: React.FC<{content: string}> = ({ content }) => {
  useStaticStyles();
  const classes = useTagContentStyles();
  return (
    <Text
      className={classes.Text}
      aria-label={`Selected list: ${content}`}
    >
      {content}
    </Text>
  );
};
